if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      /* Sync .is-selected on labels so :checked + label repaint isn't relied on (iOS Safari) */
      syncSelectedState() {
        this.querySelectorAll('.product-form__input').forEach((fieldset) => {
          const radios = fieldset.querySelectorAll('input[type=radio]');
          if (!radios.length) return;
          radios.forEach((radio) => {
            const label = radio.id
              ? fieldset.querySelector(`label[for="${radio.id}"]`)
              : radio.nextElementSibling;
            if (label && label.matches('label')) {
              label.classList.toggle('is-selected', radio.checked);
            }
          });
        });
      }

      connectedCallback() {
        this.syncSelectedState();
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const fieldset = target.closest('.product-form__input');
          const labelSpan = fieldset && fieldset.querySelector('[data-selected-swatch-value]');
          if (labelSpan) labelSpan.textContent = target.getAttribute('data-size-label') || value;
          const usSizeSpan = fieldset && fieldset.querySelector('[data-selected-us-size]');
          if (usSizeSpan) {
            const usSize = target.getAttribute('data-us-size') || '';
            usSizeSpan.textContent = usSize ? `(${usSize})` : '';
            usSizeSpan.toggleAttribute('hidden', !usSize);
          }
          this.syncSelectedState();
        }
      }
    }
  );
}
